module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_6005.89ea7c90.png";